import type { GenerationTier } from '../../types';
import { CHART_TIER_COLORS } from './chartTheme';

export const TIER_COLORS: Record<GenerationTier, string> = {
  tier0: CHART_TIER_COLORS[0],
  tier1: CHART_TIER_COLORS[1],
  tier2: CHART_TIER_COLORS[2],
  tier3: CHART_TIER_COLORS[3],
  tier4: CHART_TIER_COLORS[4],
};

export const TIER_LABELS: Record<GenerationTier, string> = {
  tier0: 'Tier 0',
  tier1: 'Tier 1',
  tier2: 'Tier 2',
  tier3: 'Tier 3',
  tier4: 'Tier 4',
};
